import { useInfiniteQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Link } from "react-router";
import { admin } from "../lib/api";
import { useCurrency } from "../lib/auth";
import { date, money } from "../lib/format";
import type { Customer, List } from "../lib/types";
import { Badge, Button, PageHeader, Spinner, Table } from "../components/ui";

export default function Customers() {
  const currency = useCurrency();
  const [q, setQ] = useState("");
  const [term, setTerm] = useState("");
  const query = useInfiniteQuery({
    queryKey: ["customers", term],
    initialPageParam: "",
    queryFn: ({ pageParam }) => {
      const p = new URLSearchParams({ limit: "50" });
      if (term) p.set("q", term);
      if (pageParam) p.set("cursor", pageParam);
      return admin.get<List<Customer>>(`/customers?${p}`);
    },
    getNextPageParam: (l) => l.next_cursor || undefined,
  });
  const rows = query.data?.pages.flatMap((p) => p.data) ?? [];

  return (
    <>
      <PageHeader title="Clienți" />
      <form className="mb-4" onSubmit={(e) => { e.preventDefault(); setTerm(q.trim()); }}>
        <input className="input max-w-sm" placeholder="Nume, email sau telefon…" value={q} onChange={(e) => setQ(e.target.value)} />
      </form>
      {query.isLoading ? <Spinner /> : (
        <Table head={["Client", "Telefon", "Cont", "Comenzi", "Total cheltuit", "Client din"]} empty={rows.length === 0}>
          {rows.map((c) => (
            <tr key={c.id} className="hover:bg-slate-50">
              <td className="px-4 py-3">
                <div className="font-semibold">{[c.first_name, c.last_name].filter(Boolean).join(" ") || "—"}</div>
                <div className="text-xs text-slate-500">{c.email}</div>
              </td>
              <td className="px-4 py-3">{c.phone || "—"}</td>
              <td className="px-4 py-3">{c.has_account ? <Badge tone="green">Cont</Badge> : <Badge>Guest</Badge>}</td>
              <td className="px-4 py-3">
                {c.orders_count > 0 ? <Link className="text-brand" to={`/orders?customer_id=${c.id}`}>{c.orders_count}</Link> : 0}
              </td>
              <td className="px-4 py-3 font-semibold">{money(c.total_spent, currency)}</td>
              <td className="px-4 py-3 text-slate-500">{date(c.created_at)}</td>
            </tr>
          ))}
        </Table>
      )}
      {query.hasNextPage && <div className="mt-4 text-center"><Button variant="secondary" onClick={() => query.fetchNextPage()}>Încarcă mai multe</Button></div>}
    </>
  );
}
